export default function MySQL_LIMIT() {
  return (
    <div>
      <h2>MySQL_LIMIT</h2>    </div>
  );
}